import React from 'react';
import { NavLink } from 'react-router-dom';

export default function Sidebar({ systemStatus, cycleCount, lastUpdate }) {
  return (
    <nav className="sidebar">
      <div className="sidebar-brand">
        <h1>OptionSelling</h1>
      </div>

      <div className="sidebar-nav">
        <NavLink to="/" className={({ isActive }) => `sidebar-link ${isActive ? 'active' : ''}`} end>
          <span className="sidebar-icon">📊</span>
          <span>Dashboard</span>
        </NavLink>
        <NavLink to="/indicators" className={({ isActive }) => `sidebar-link ${isActive ? 'active' : ''}`}>
          <span className="sidebar-icon">📈</span>
          <span>Indicators</span>
        </NavLink>
        <NavLink to="/strategies" className={({ isActive }) => `sidebar-link ${isActive ? 'active' : ''}`}>
          <span className="sidebar-icon">⚡</span>
          <span>Strategies</span>
        </NavLink>
        <NavLink to="/manual-trade" className={({ isActive }) => `sidebar-link ${isActive ? 'active' : ''}`}>
          <span className="sidebar-icon">🎯</span>
          <span>Manual Trade</span>
        </NavLink>
        <NavLink to="/rolling-strangle" className={({ isActive }) => `sidebar-link ${isActive ? 'active' : ''}`}>
          <span className="sidebar-icon">🔄</span>
          <span>Rolling Strangle</span>
        </NavLink>
        <NavLink to="/backtest" className={({ isActive }) => `sidebar-link ${isActive ? 'active' : ''}`}>
          <span className="sidebar-icon">🔬</span>
          <span>Backtest</span>
        </NavLink>
        <NavLink to="/trade-history" className={({ isActive }) => `sidebar-link ${isActive ? 'active' : ''}`}>
          <span className="sidebar-icon">📅</span>
          <span>Trade History</span>
        </NavLink>
        <NavLink to="/settings" className={({ isActive }) => `sidebar-link ${isActive ? 'active' : ''}`}>
          <span className="sidebar-icon">⚙️</span>
          <span>Settings</span>
        </NavLink>
      </div>

      <div className="sidebar-footer">
        <div className="sidebar-status">
          <span className={`status-dot ${systemStatus?.market_hours ? 'live' : 'closed'}`} />
          <span>{systemStatus?.market_hours ? 'Market Live' : 'Market Closed'}</span>
        </div>
        <div className="sidebar-meta">
          <span>Cycle #{cycleCount}</span>
          <span className="sidebar-update">{lastUpdate || '—'}</span>
        </div>
      </div>
    </nav>
  );
}
